import { Injectable, ErrorHandler } from '@angular/core';

import * as atatus from 'atatus-spa';
import { environment } from 'src/environments/environment';
atatus.config('a741e9c639804fdea4563579050c042a', { hashRoutes: true, console: false, debugMode: environment.production, offline: true, tags: [environment.message] }).install();

// Clean path in the stack trace
if (atatus) {
  atatus.onBeforeErrorSend(function (payload: any) {
    var backTraces = payload.backTraces;
    for (var i = 0; i < backTraces.length; i++) {
      var backTrace = backTraces[i];
      var filename = backTrace.f;
      var indexOfJsRoot = filename.indexOf("/www/");
      if (indexOfJsRoot !== -1) {
        backTrace.f = filename.substring(indexOfJsRoot);
      }
    }
    return true;
  });
}

@Injectable()
export class AtatusErrorHandler extends ErrorHandler {
  handleError(error: any): void {
    super.handleError(error);
    if (atatus) {
      // Send the error to Atatus
      atatus.notify(error.originalError || error);
    }
  }
}

